import http from "../../api";

export default {
  namespaced: true,
  actions: {
    usersGet({}, body) {
      return http.post("/customer/list", body);
    },
    usersKycGet({}, body) {
      return http.post("/customer/kyc/list", body);
    },
    usersKycVerifiedGet({}, body) {
      return http.post("/customer/kyc/list/verified", body);
    },
    usersKycRejectedGet({}, body) {
      return http.post("/customer/kyc/list/rejected", body);
    },
    lastHistoryGet({}, body) {
      return http.post("/customer/history/last", body);
    },
    cashInHistoryGet({}, body) {
      return http.post("/customer/history/cash-in", body);
    },
    cashIn({}, body) {
      return http.post("/main/cash-in", body);
    },
    cashInBank({}, body) {
      return http.post("/main/cash-in-bank", body);
    },
    cashInOnline({}, body) {
      return http.post("/main/cash-in-online", body);
    },
    userFind({}, body) {
      return http.get("/customer/find?login=" + body);
    },
    ["customer/get"]({}, { UserGuid }) {
      return http.get("/customer/" + UserGuid);
    },
    getLock({}, { UserGuid }) {
      return http.get("/customer/lock/" + UserGuid);
    },
    setLock({}, { UserGuid, Reason }) {
      return http.post("/customer/lock/" + UserGuid, { Reason });
    },
    deleteLock({}, { UserGuid }) {
      return http.delete("/customer/lock/" + UserGuid);
    },
    getKyc({}, { UserGuid }) {
      return http.get("/customer/kyc/" + UserGuid);
    },
    getLevel({}, { UserGuid }) {
      return http.get("/customer/level/" + UserGuid);
    },
    setKycStatus({}, { UserGuid, Status, Id, Reason }) {
      return http.post("/customer/kyc/" + UserGuid, { Status, Id, Reason });
    },
    setUserLevel({}, { UserGuid, Level }) {
      return http.post("/customer/level/" + UserGuid, { Level });
    },
    sendNotification({}, { Message, UserGuid }) {
      return http.post("/customer/notification/" + UserGuid, { Message });
    },
    sendNotificationToAll({}, { Message }) {
      return http.post("/customer/notification/", { Message });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js